import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-lowfreqimage',
  templateUrl: './lowFreqImage.component.html',
  styleUrls: ['../../IconDesings.scss'],
})

export class LowFreqImageComponent {
  constructor() {
  }
}